import * as actions from './actions';

const initialState = {
    funFact: null,
    error: null,
    initial: false,
    loading: false,
};

const funFactReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.FETCH_FUN_FACT.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_FUN_FACT.SUCCESS: {
            const { funFact } = action.payload;
            return { ...state, loading: false, initial: true, funFact };
        }

        case actions.FETCH_FUN_FACT.FAILURE:
            return { ...state, loading: false, initial: false, error: action.payload.error };

        default:
            return state;
    }
};

export default funFactReducer;
